/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfChargePointSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateChargePointCommand, type CreateChargePointCommand, type PaginatedListOfChargePointSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ConsumptionRequestBuilderNavigationMetadata, type ConsumptionRequestBuilder } from './consumption/index.js';
// @ts-ignore
import { ChargepointsItemRequestBuilderNavigationMetadata, ChargepointsItemRequestBuilderRequestsMetadata, type ChargepointsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { MakesRequestBuilderNavigationMetadata, type MakesRequestBuilder } from './makes/index.js';
// @ts-ignore
import { type VolumeRequestBuilder, VolumeRequestBuilderRequestsMetadata } from './volume/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints
 */
export interface ChargepointsRequestBuilder extends BaseRequestBuilder<ChargepointsRequestBuilder> {
    /**
     * The consumption property
     */
    get consumption(): ConsumptionRequestBuilder;
    /**
     * The makes property
     */
    get makes(): MakesRequestBuilder;
    /**
     * The volume property
     */
    get volume(): VolumeRequestBuilder;
    /**
     * Gets an item from the ApiSdk.chargepoints.item collection
     * @param id Unique identifier of the item
     * @returns {ChargepointsItemRequestBuilder}
     */
     byId(id: Guid) : ChargepointsItemRequestBuilder;
    /**
     * GetChargePointsByLocation
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfChargePointSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ChargepointsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfChargePointSummary | undefined>;
    /**
     * CreateChargePoint
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateChargePointCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetChargePointsByLocation
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ChargepointsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateChargePoint
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateChargePointCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetChargePointsByLocation
 */
export interface ChargepointsRequestBuilderGetQueryParameters {
    criteria?: string;
    locationId?: Guid;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointsRequestBuilderUriTemplate = "{+baseurl}/chargepoints{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ChargepointsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "locationId": "LocationId",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargepointsRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargepointsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: ChargepointsItemRequestBuilderRequestsMetadata,
        navigationMetadata: ChargepointsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    consumption: {
        navigationMetadata: ConsumptionRequestBuilderNavigationMetadata,
    },
    makes: {
        navigationMetadata: MakesRequestBuilderNavigationMetadata,
    },
    volume: {
        requestsMetadata: VolumeRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargepointsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: "{+baseurl}/chargepoints?LocationId={LocationId}{&Criteria*,PageNumber*,PageSize*,SortExpression*}",
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfChargePointSummaryFromDiscriminatorValue,
        queryParametersMapper: ChargepointsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: ChargepointsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateChargePointCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
